var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @flow
var fcbuffer = require('fcbuffer');
var assert = require('assert');
var asn1 = require('asn1-ber');
// const { TextEncoder, TextDecoder } = require('text-encoding');
import { Serialize } from 'eosjs';
var LedgerDataManager = /** @class */ (function () {
    function LedgerDataManager() {
    }
    LedgerDataManager.prototype.serialize = function (chainId, transaction, types, api) {
        return __awaiter(this, void 0, void 0, function () {
            var fcbufferMatch, writer, action, contract, sertype, sertype, sertype, sertype, sertype, sertype, sertype, sertype, sertype, sertype, sertype, sertype, i, authorization, sertype, sertype, b, data, sertype, sertype, servalue, sertype;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fcbufferMatch = '';
                        writer = new asn1.BerWriter();
                        action = transaction.actions[0];
                        return [4 /*yield*/, api.getContract(action.account)];
                    case 1:
                        contract = _a.sent();
                        sertype = 'checksum256';
                        encode(writer, sertype, chainId, types, 'chainId');
                        sertype = 'time_point_sec';
                        fcbufferMatch =
                            fcbufferMatch + encode(writer, sertype, transaction.expiration, types, 'transaction.expiration (0404)');
                        sertype = 'uint16';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, transaction.ref_block_num, types, 'transaction.ref_block_num (0402)');
                        sertype = 'uint32';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, transaction.ref_block_prefix, types, 'transaction.ref_block_prefix (0404)');
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch + encode(writer, sertype, 0, types, 'transaction.net_usage_words (hard coded to 0) (0401)');
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, transaction.max_cpu_usage_ms, types, 'transaction.max_cpu_usage_ms  (0401)');
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch + encode(writer, sertype, transaction.delay_sec, types, 'transaction.delay_sec (0401)');
                        assert(transaction.context_free_actions.length === 0);
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, 0, types, 'Not sure what the heck this is (Hard Coded to 0) (0401)');
                        assert(transaction.actions.length === 1);
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, 1, types, 'Not sure what the heck this is (Hard Coded to 1) (0401)');
                        sertype = 'name';
                        fcbufferMatch = fcbufferMatch + encode(writer, sertype, action.account, types, 'action.account (0408)');
                        sertype = 'name';
                        fcbufferMatch = fcbufferMatch + encode(writer, sertype, action.name, types, 'action.name (0408)');
                        sertype = 'uint8';
                        fcbufferMatch =
                            fcbufferMatch + encode(writer, sertype, action.authorization.length, types, 'action.authorization.length');
                        for (i = 0; i < action.authorization.length; i += 1) {
                            authorization = action.authorization[i];
                            sertype = 'name';
                            fcbufferMatch =
                                fcbufferMatch +
                                    encode(writer, sertype, authorization.actor, types, 'authorization.actor (was account_name)');
                            sertype = 'name';
                            fcbufferMatch =
                                fcbufferMatch +
                                    encode(writer, sertype, authorization.permission, types, 'authorization.permission (was permission_name)');
                        }
                        b = Serialize.serializeActionData(contract, action.account, action.name, action.data, null, null);
                        data = Buffer.from(b, 'hex');
                        sertype = 'varuint32';
                        fcbufferMatch =
                            fcbufferMatch +
                                encode(writer, sertype, data.length, types, 'data.length (IMPORTANT, this is a varuint32 - the byte length varies depending on the data size)');
                        fcbufferMatch = fcbufferMatch + encodeRaw(writer, data, data.length, 'raw data not serialized');
                        assert(writer, transaction.transaction_extensions.length === 0);
                        sertype = 'uint8';
                        servalue = 0;
                        fcbufferMatch = fcbufferMatch + encode(writer, sertype, servalue, types, 'Hard Coded to 0');
                        sertype = 'checksum256';
                        encode(writer, sertype, Buffer.alloc(32, 0).toString('hex'), types, "Buffer.alloc(32, 0).toString('hex')");
                        // This can be used as a sanity check against the transaction that was generated by
                        // console.log('fcbufferMatch:');
                        // console.log(fcbufferMatch);
                        return [2 /*return*/, writer.buffer];
                }
            });
        });
    };
    return LedgerDataManager;
}());
export default LedgerDataManager;
function encodeRaw(writter, rawvalue, rawvalueLength, fieldDescription) {
    // var debugBuffer = new Buffer(rawvalue);
    // console.log("rawvalue that we're being asked to DER encode: ");
    // console.log(debugBuffer.toString('hex'));
    var buffer = new Buffer(rawvalue);
    writter.writeBuffer(buffer, asn1.Ber.OctetString);
    var tmpwriter = new asn1.BerWriter();
    tmpwriter.writeBuffer(buffer, asn1.Ber.OctetString);
    // console.log(fieldDescription + ' -> ' + 'rawdata' + ' -> ' + rawvalue + '-> ' + tmpwriter.buffer.toString('hex'));
    // This is a veriable length prefix so we need to calculate how much to truncate off the front.
    var length = tmpwriter.buffer.toString('hex').length;
    var rawvalueHexLength = rawvalueLength * 2;
    var lenthDiff = length - rawvalueHexLength;
    return tmpwriter.buffer.toString('hex').slice(lenthDiff);
}
function encode(writter, sertype, rawvalue, types, fieldDescription) {
    var buf = new Serialize.SerialBuffer();
    types.get(sertype).serialize(buf, rawvalue);
    var buffer = new Buffer(buf.asUint8Array());
    writter.writeBuffer(buffer, asn1.Ber.OctetString);
    var tmpwriter = new asn1.BerWriter();
    tmpwriter.writeBuffer(buffer, asn1.Ber.OctetString);
    // console.log(fieldDescription + ' -> ' + sertype + ' -> ' + rawvalue + '-> ' + tmpwriter.buffer.toString('hex'));
    return tmpwriter.buffer.toString('hex').slice(4);
}
//# sourceMappingURL=LedgerDataManager.js.map